export const question = ({
  quizId,
  questionId = '',
}: {
  quizId: number | string;
  questionId?: number | string | Array<string | number>;
}) =>
  `/quizzes/${quizId}/question${
    Array.isArray(questionId) ? '' : `/${questionId}`
  }`;

export const questionOrder = ({
  quizId,
  questionId,
}: {
  quizId: number;
  questionId: number;
}) => `${question({ quizId, questionId })}/order`;

export const bulkQuestions = ({ quizId }: { quizId: string }) =>
  `/quizzes/${quizId}/questions`;
